import { getWeek, getYear } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { BRAND_PATHS } from "@chef/constants";
import { AppShell } from "@chef/feature-app-shell";
import { nextDeliveryWeekDateObj } from "@chef/helpers";
import { selectAddonProducts, toggleCartModal } from "@chef/state-management";
import { intl } from "./Headers.Intl";

export const SubscriptionStandaloneHeader = () => {
  const dispatch = useDispatch();

  const basketProducts = useSelector(selectAddonProducts);
  const basketCount = basketProducts.reduce((count, product) => {
    return count + product.quantity;
  }, 0);

  const deliveryWeek = nextDeliveryWeekDateObj();
  const week = getWeek(deliveryWeek);
  const year = getYear(deliveryWeek);
  const openCartModal = () => dispatch(toggleCartModal({ week, year }));

  return (
    <AppShell.Header
      variant="steps"
      steps={[...intl.STEPS]}
      backHref={BRAND_PATHS.MY_SUBSCRIPTION_LINK}
      exitLabel={intl.MY_SUBSCRIPTION}
      current={1}
      cartCount={basketCount}
      onCartClick={openCartModal}
    />
  );
};

export const SubscriptionConfirmationHeader = () => (
  <AppShell.Header
    variant="steps"
    steps={[...intl.STEPS]}
    backHref={BRAND_PATHS.ADDONS_SUBSCRIPTION_PATH}
    exitLabel={intl.ADD_ADDONS}
    current={2}
  />
);
